'use strict';

angular.module('directives.TopBar', [])

.provider('topBarService', function () {
    var provider = this;

    provider.config = {};
    provider.config.defaultModuleName = '';

    provider.$get = function () {
        return provider;
    };

    provider.setModule = function (name) {
        provider.config.moduleName = name;
    };

    provider.getModuleName = function () {
        if (_.isUndefined(provider.config.moduleName)) return provider.config.defaultModuleName;
        return provider.config.moduleName;
    };

    provider.getDefaultModuleName = function () {
        return provider.config.defaultModuleName;
    };

    provider.setTitleAndIcon = function (title1, icon1, title2, icon2, title3, icon3) {

        provider.setTopBar({
            title1: title1,
            icon1: icon1,
            state1: null,
            title2: title2,
            icon2: icon2,
            state2: null,
            title3: title3,
            icon3: icon3,
            state3: null
        });
    };

    /**
     * Change the top bar breadcrumb
     *
     * @param [config.title1] {string} name of the first level title
     * @param [config.icon1] {string} icon to use for the first level title
     * @param [config.state1] {string} state to access when user clicks on title 2
     * @param [config.title2] {string} name of the second level title
     * @param [config.icon2] {string} icon to use for the second level title
     * @param [config.state2] {string} state to access when user clicks on title 3
     * @param [config.title3] {string} name of the third level title
     * @param [config.icon3] {string} icon to use for the third level title
     * @param [config.state3] {string} state to access when user clicks on title 3
     */
    provider.setTopBar = function (config) {
        if (!config) {
            provider.setTitleAndIcon();
            return;
        }

        provider.config.title1 = config.title1;
        provider.config.icon1 = config.icon1;
        provider.config.state1 = config.state1;
        provider.config.title2 = config.title2;
        provider.config.icon2 = config.icon2;
        provider.config.state2 = config.state2;
        provider.config.title3 = config.title3;
        provider.config.icon3 = config.icon3;
        provider.config.state3 = config.state3;
    }
})

.directive('topBar', function () {
    return {
        controller: ['$scope', 'topBarService', '$state', function ($scope, topBarService, $state) {
            $scope.config = topBarService.config;
            $scope.getModuleName = topBarService.getModuleName;
            $scope.getDefaultModuleName = topBarService.getDefaultModuleName;

            $scope.isState = function (stateName) {
                return $state.get(stateName);
            }

            $scope.gotToState = function (stateName) {
                if (!$scope.isState(stateName)) return;
                return $state.go(stateName);
            };
        }],
        link: function (scope, element, attr) {
            scope.hover = false;

            scope.getModule = function () {
                var defMod = scope.getDefaultModuleName();
                var mod = scope.getModuleName();

                if (defMod === mod) return mod;

                defMod = defMod + ' ' + mod;
                mod = 'GOV ' + mod;

                if (scope.hover) return defMod;
                return mod;
            }
        }
    }
});
